import cx from 'classnames';
import {isEmpty, startsWith} from 'lodash';
import {useMemo, useCallback} from 'react';
import {default as PhoneInputControl, PhoneInputProps} from 'react-phone-input-2';
import ar from 'react-phone-input-2/lang/ar.json';
import es from 'react-phone-input-2/lang/es.json';

import {Language} from 'constants/language';
import {LanguageService} from 'services';

import 'react-phone-input-2/lib/style.css';
import './styles.scss';

type Props = PhoneInputProps & {
    label?: string;
    className?: string;
    underlined?: boolean;
    errors?: string | string[];
    helperText?: string;
    error?: boolean;
    styled?: boolean;
};

export const PhoneInput: React.FC<Props> = ({
    inputProps,
    value,
    label,
    className,
    onChange: onChangeHandler,
    onBlur,
    onFocus,
    errors,
    helperText,
    placeholder,
    disabled = false,
    underlined = false,
    error = false,
    styled = true
}: Props) => {

    const onChange = useCallback((phoneNumber, data, event, formattedValue) => {
        const numberWithPlus = isEmpty(phoneNumber) || startsWith(phoneNumber, '+') ? phoneNumber : `+${phoneNumber}`;
        onChangeHandler?.(numberWithPlus, data, event, formattedValue);
    }, [onChangeHandler]);

    const localization = useMemo(() => {
        const language = LanguageService.getLanguage();
        if (language === Language.Spanish) {
            return es;
        } else if (language === Language.Arabic) {
            return ar;
        } else {
            return ({});
        }
    }, []);

    const message = useMemo(() => errors || helperText, [errors, helperText]);

    return (
        <div className={cx(className, {'vs-phone-input': styled, underlined})}>
            {label &&
                <div className={cx('label tw-text-sm', {
                    'tw-text-alert': !!error,
                    'tw-text-default': !error,
                    active: !value
                })}
                >
                    {label}
                </div>}
            <PhoneInputControl
                inputProps={inputProps}
                containerClass={cx('container', {underlined, error})}
                inputClass='input'
                dropdownClass='dropdown'
                jumpCursorToEnd
                buttonClass='country-dropdown'
                localization={localization}
                value={value}
                disabled={disabled}
                placeholder={placeholder}
                onChange={onChange}
                onBlur={onBlur}
                onFocus={onFocus}
            />
            {message && <span className={`message tw-text-sm ${error ? 'error tw-text-alert' : 'tw-text-default'}`}>{message}</span>}
        </div>
    );
};
